import { render, staticRenderFns } from "./question-lettre.vue?vue&type=template&id=3c0a68dc&"
import script from "./question-lettre.vue?vue&type=script&lang=js&"
export * from "./question-lettre.vue?vue&type=script&lang=js&"
import style0 from "./question-lettre.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports